import { useState } from 'react';
import Drawer from '../../components/Drawer';
import Button from '../../components/Button';
import AuthMessage from '../../components/AuthMessage';
import form from '../../styles/form.module.css';

const GROUPS = ['Ops', 'Admin', 'Delivery'];

export default function InviteStaffDrawer({ open, onClose, onInvite }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneDigits, setPhoneDigits] = useState('');
  const [group, setGroup] = useState('Ops');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const reset = () => {
    setName('');
    setEmail('');
    setPhoneDigits('');
    setGroup('Ops');
    setError('');
  };

  const handleClose = () => {
    if (submitting) return;
    reset();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (phoneDigits.length !== 10) {
      setError('Enter a valid 10-digit phone number.');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await onInvite({ phone: `+91${phoneDigits}`, email, group, name: name || undefined });
      reset();
    } catch (err) {
      setError(err.message || 'Could not send the invite. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      title="Invite staff"
      subtitle="They'll be added to Cognito and assigned the selected group"
      width={400}
      footer={
        <>
          <Button variant="ghost" onClick={handleClose} disabled={submitting}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Sending…' : 'Send invite'}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <AuthMessage>{error}</AuthMessage>

        <label className={form.field}>
          <span className={form.label}>Full name (optional)</span>
          <input className={form.input} value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Ananya Rao" />
        </label>
        <label className={form.field}>
          <span className={form.label}>Phone number</span>
          <div className={`${form.prefixInput} ${form.prefixInputWide}`}>
            <span>+91</span>
            <input
              className={form.input}
              type="tel"
              inputMode="numeric"
              required
              value={phoneDigits}
              onChange={(e) => setPhoneDigits(e.target.value.replace(/\D/g, '').slice(0, 10))}
              placeholder="98765 43210"
            />
          </div>
        </label>
        <label className={form.field}>
          <span className={form.label}>Work email</span>
          <input className={form.input} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ananya@bhimastore.in" />
        </label>
        <label className={form.field}>
          <span className={form.label}>Role / Cognito group</span>
          <select className={form.select} value={group} onChange={(e) => setGroup(e.target.value)}>
            {GROUPS.map((g) => <option key={g} value={g}>{g}</option>)}
          </select>
        </label>
      </form>
    </Drawer>
  );
}
